<template>
  <v-container id="contact-detail" fluid tag="section">
    <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="header-contact">
          <div class="font-weight-light card-title mt-2">Tạo khách hàng</div>
        </div>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <div style="position: relative">
          <div class="header-group-btn">
            <v-btn
              class="mb-2"
              color="success"
              @click.prevent="handleSubmit(clickCreateContact); scrollToError()"
            >Lưu Lại</v-btn>
            <v-btn class="mb-2" color="primary" @click="clickCancel">Huỷ Bỏ</v-btn>
          </div>
        </div>
        <v-row class="px-4">
          <v-col cols="12" sm="4">
            <contact-detail-card
              :contactColumns="contactColumns"
              :title-contact="'CONTACT'"
              :data-form="dataForm"
            />
            <contact-detail-card
              :contactColumns="contactColumns"
              v-if="parentCustomersLength === 0"
              :indexCustomer="-1"
              :data-form="dataForm"
              :title-contact="'PARENT'"
            />
            <template
              v-for="(customer, index) in dataForm.customers.filter(customer => customer.position !== 'child' && !_.get(customer,'isDeleted', false))"
            >
              <contact-detail-card
                :contactColumns="contactColumns"
                :key="'customer-parent-' + index"
                :customer="customer"
                :indexCustomer="index"
                :data-form="dataForm"
                :title-contact="'PARENT'"
              />
            </template>
          </v-col>
          <v-col cols="12" sm="4">
            <contact-detail-card
              v-if="childCustomersLength === 0"
              :contactColumns="contactColumns"
              :indexCustomer="-1"
              :title-contact="'CHILD'"
              :data-form="dataForm"
            />
            <template
              v-for="(customer, index) in dataForm.customers.filter(customer => customer.position === 'child' && !_.get(customer,'isDeleted', false))"
            >
              <contact-detail-card
                v-if="showChild"
                :contactColumns="contactColumns"
                :key="'customer-child-' + index"
                :customer="customer"
                :indexCustomer="index"
                :title-contact="'CHILD'"
                :data-form="dataForm"
              />
            </template>
          </v-col>
          <v-col cols="12" sm="4">
            <contact-detail-card
              :title-contact="'CUSTOMER'"
              :contactColumns="contactColumns"
              :contact-sources="contactSources"
              :users="users"
              :product-groups="productGroups"
              :data-form="dataForm"
              :schoolLevels="schoolLevels"
              :types="types"
            />
          </v-col>
        </v-row>
      </validation-observer>
    </base-material-card>
  </v-container>
</template>

<script>
import ContactDetailCard from './components/ContactDetailCard';
import RepositoryFactory from '../../repositories/RepositoryFactory';
const ContactSourceRepository = RepositoryFactory.get('contact_source');
const ProductGroupRepository = RepositoryFactory.get('product_group');
const ContactRepository = RepositoryFactory.get('contact');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
const SchoolLevelRepository = RepositoryFactory.get('school_level');
const TypeRepository = RepositoryFactory.get('type');

export default {
  components: { ContactDetailCard },
  data() {
    return {
      combos: [],
      products: [],
      contactSources: [],
      users: [],
      productGroups: [],
      dataForm: {
        // Main Contact
        position: 'other',
        // End Main Contact
        // Định Vị Khách Hàng
        contactSourceIds: [],
        groupIds: [],
        productGroups: [],
        customers: [
          {
            mobile: '',
            isMainCustomer: true,
            position: 'other',
            phones: [],
            courseRegister: []
          }
        ],
        typeId: this.$store.state.module.typeId,
        schoolLevelId: this.$store.state.module.schoolLevelId
      },
      contactColumns: {},
      showChild: true,
      schoolLevels: [],
      types: [],
      watchModule: ''
    };
  },
  async created() {
    const loader = this.$loading.show();
    await Promise.all([
      this.getProductGroups(),
      this.getUsers(),
      this.getContactSources(),
      this.getContactColumns(),
      this.getListSchoolLevel(),
      this.getListType()
    ]);
    loader.hide();
    Bus.$on('contact-change-postion', () => {
       // render child again
      this.showChild = false;
      setTimeout(() => {
        this.showChild = true;
      }, 10);
    });

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.dataForm.userId = ''
        this.getUsers()
        this.getProductGroups()
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('contact-change-postion');
    this.watchModule()
  },
  computed: {
    childCustomersLength() {
      return this.dataForm.customers.filter(
        customer => customer.position === 'child'
      ).length;
    },
    parentCustomersLength() {
      return this.dataForm.customers.filter(
        customer => customer.position !== 'child'
      ).length;
    }
  },
  methods: {
    async getContactColumns() {
      const response = await ContactRepository.getContactColumns();
      this.loading = false;
      if (response.success) {
        this.contactColumns = _.get(response, 'data', {});
      } else {
        this.contactColumns = {};
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    checkDuplicateCustomer() {
      let checkObjectChild = {};
      let checkObjectNotChild = {};
      let statusChildError = false;
      this.dataForm.customers.forEach(dataCustomer => {
        if (!_.get(dataCustomer, 'isDeleted', false)) {
          const position = _.get(dataCustomer, 'position', 'other');
          if (position === 'child') {
            const keyChild = dataCustomer.birthday + '-' + _.trim(dataCustomer.fullName).toLocaleLowerCase();
            if (checkObjectChild[keyChild]) {
              statusChildError = true;
            }
            checkObjectChild[keyChild] = true;
          } else {
            if (!checkObjectNotChild[position]) {
              checkObjectNotChild[position] = 0;
            }
            checkObjectNotChild[position] += 1;
          }
        }
      });
      if (statusChildError) {
        return 'Thông tin con bị trùng !!!';
      }
      if (checkObjectNotChild['father'] > 1 ) {
        return 'Thông tin bố đã tồn tại';
      }
      if (checkObjectNotChild['mother'] > 1) {
        return 'Thông tin mẹ đã tồn tại';
      }
      return '';
    },
    async clickCreateContact() {
      let checkDuplicateCustomer = this.checkDuplicateCustomer();
      if (checkDuplicateCustomer) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: checkDuplicateCustomer
        });
      }
      const dataUpdate = {
        userId: _.get(this.dataForm, 'userId', null),
        productGroups: _.get(this.dataForm, 'productGroups', []),
        userMarketingName: _.trim(this.dataForm.userMarketingName),
        contactSourceIds: _.get(this.dataForm, 'contactSourceIds', []),
        schoolLevelId: _.get(this.dataForm, 'schoolLevelId', null),
        typeId: _.get(this.dataForm, 'typeId', null),
        description: _.trim(this.dataForm.description),
        customers: [],
        dynamicColumns:
          _.get(this.contactColumns, 'contact', []).map(dataAttribute => {
            return {
              columnId: dataAttribute.id,
              value: _.trim(this.dataForm[dataAttribute.id])
            };
          }) || []
      };
      let checkErrorPhone = false;
      dataUpdate.customers = this.dataForm.customers.map(customer => {
        const customerTemp = _.cloneDeep({ ...customer });
        const customerTempMobile = customerTemp.mobile;
        if (
          !_.get(customerTemp, 'isMainCustomer', false) &&
          customerTemp.mobile &&
          customerTemp.mobile !== ''
        ) {
          if (!Array.isArray(customerTemp.phones)) {
            customerTemp.phones = [];
          }
          customerTemp.phones.unshift(customerTemp.mobile);
          customerTemp.mobile = '';
        }
        if (customerTemp.phoneSub) {
          if (customerTemp.phoneSub === customerTempMobile) {
            checkErrorPhone = true;
          }
          customerTemp.phones.push(customerTemp.phoneSub);
        }
        if (
          _.get(customerTemp, 'isMainCustomer', false) &&
          !_.get(customerTemp, 'fullName', '')
        ) {
          customerTemp.fullName = _.get(customerTemp, 'mobile', '');
        }

        let dynamicColumns = [];
        if (_.get(customerTemp, 'isMainCustomer', false)) {
          dynamicColumns =
            _.get(this.contactColumns, 'main_customer', []).map(
              dataAttribute => {
                return {
                  columnId: dataAttribute.id,
                  value: _.trim(customerTemp[dataAttribute.id])
                };
              }
            ) || [];
        }
        let typeColumn = _.get(customer, 'position', 'other') === 'child' ? 'child' : 'parent';
        dynamicColumns = dynamicColumns.concat(
          _.get(this.contactColumns, typeColumn, []).map(dataAttribute => {
            return {
              columnId: dataAttribute.id,
              value: _.trim(customerTemp[dataAttribute.id])
            };
          }) || []
        );
        return {
          mobile: _.get(customerTemp, 'mobile', ''),
          isMainCustomer: _.get(customer, 'isMainCustomer', false),
          fullName: _.trim(customerTemp.fullName),
          birthday: _.get(customer, 'birthday', null),
          birthdayDescription: _.trim(customer.birthdayDescription),
          email: _.get(customer, 'email', ''),
          capability: _.trim(customer.capability),
          position: _.get(customer, 'position', 'other'),
          positionTitle: _.trim(customer.positionTitle) || 'Khác',
          tinhId: _.get(customer, 'tinhId', 0) || 0,
          huyenId: _.get(customer, 'huyenId', 0) || 0,
          xaId: _.get(customer, 'xaId', 0) || 0,
          detailAddress: _.trim(customer.detailAddress),
          description: _.trim(customer.description),
          productDescription: _.trim(customer.productDescription),
          phones: _.get(customerTemp, 'phones', []),
          dynamicColumns
        };
      });
      if (checkErrorPhone) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Số điện thoại phụ không được giống số điện thoại chính',
        });
      }
      this.loading = this.$loading.show();
      const response = await ContactRepository.create(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else {
        this.$swal({
          title: 'Tạo Khách Hàng Thành Công!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.$router.push({
            name: 'ContactList'
          });
        });
      }
    },
    clickCancel() {
      this.$router.push({
        name: 'ContactList'
      });
    },
    async getProductGroups() {
      const respond = await ProductGroupRepository.list({ 
        limit: 100, 
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      if (_.get(respond, 'success', false)) {
        this.productGroups = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getContactSources() {
      const respond = await ContactSourceRepository.list({ limit: 100, status: 'active' });
      if (_.get(respond, 'success', false)) {
        this.contactSources = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getUsers() {
      const res = await OrganizationMachineRepository.listUser({ 
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getListSchoolLevel() {
      if(this.$store.state.listSchoolLevelDrawer) {
        this.schoolLevels  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
        return
      }

      const res = await SchoolLevelRepository.listTypeSchoolLevel()
      if (res.success) {
        this.schoolLevels = _.get(res, 'data', [])
      } else {
        this.schoolLevels = []
      }
    },
    async getListType() {
      const res = await TypeRepository.list({limit: 1000})
      if (res.success) {
        this.types = _.get(res, 'data', [])
      } else {
        this.types = []
      }
    },
  }
};
</script>
